import styled from 'styled-components';

export const TitleText = styled.h2<{
  weight?: string;
  noMargin?: boolean;
  fontSize?: string;
}>`
  font-family: ${(props) =>
    props.theme.atlas.typography.semantic.body.fontFamily};
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
  font-size: ${(props) => (props.fontSize === 'small' ? '14px' : '16px')};
  font-weight: ${(props) => {
    switch (props.weight) {
      case 'bold':
        return '600';
      case 'regular':
        return '400';
      case 'light':
        return '300';
    }
  }};
  margin: ${(props) => (props.noMargin ? '0px' : '5px')};
`;
